import { htmlSafe } from '@ember/template';

export default function iconFill(color?: string): ReturnType<typeof htmlSafe> {
    return htmlSafe(color ? `fill:${color};` : '');
}
